import {EnrollEntranceExamsInfo} from '../../../../model/edu-info/enroll-entrance-exams-info';
import {ParticipateInRanging} from '../../../../../../../common/enums/participate-in-ranging.enum';

export class AlternativeCollegeItem {
  id: number = null;
  collegeId: number = null;
  studyformId = 0;
  specId = 0;
  specialExamProvided = false;
  qualificationId: number = null;
  active = true;
  sourceCollege = false;
  entrance_exams_info: EnrollEntranceExamsInfo = new EnrollEntranceExamsInfo();
  inRanging = ParticipateInRanging.NOT_DETERMINED;
  constructor(public number: number) {
    this.number = number;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-entrans-info/model/alternative-college-item.ts